var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 885.8 852.3",
    style: {
      enableBackground: "new 0 0 885.8 852.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#F87907;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M457.5,3c1.3,0.2,2.6,0.6,3.9,0.6c116.2,5.2,226.1,58.6,301.9,146.8c46.8,54.5,77.9,116.7,93.5,186.8 c0.7,3.2,1.3,6.5,1.9,9.8c0.1,0.5,0.1,0.9,0.2,1.6c-51.8,0-103.5,0-155.5,0c-9.8-32.1-24.9-61.5-45.5-88.1 c-20.5-26.5-45.1-48.5-74.1-66.4C537.7,325,491.7,455.5,445.7,586c-0.2,0-0.5,0-0.7,0c-48.7-130.3-97.3-260.7-146.2-391.5 c-28.8,17.8-53.2,39.8-73.7,66.2c-20.4,26.4-35.4,55.6-45.2,87.8c-51.7,0-103.3,0-155.4,0c1.1-5.5,2.1-10.7,3.3-16 c30.8-134.2,125.7-245.8,253.3-298c32.8-13.4,66.7-22.7,101.8-27.3c13.1-1.7,26.4-2.5,39.6-3.8c1.3-0.1,2.6-0.4,4-0.6 C436.8,3,447.1,3,457.5,3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.9,852.3c-1.1-0.2-2.1-0.5-3.2-0.6c-44.1-2.5-86.8-11.7-128-27.7C162.5,775.1,67.4,669.4,31.8,538.8 c-6.2-22.9-11.6-52.9-12.7-71.2c50.6,0,101.1,0,151.8,0c12.8,76.6,50.1,138.3,113.4,183.5c48.9,34.8,103.9,51.3,163.8,49.8 c66.4-1.7,124.8-24.6,174.6-68.6c49.6-43.9,79-99.2,89.5-164.7c1.2-0.1,2.3-0.2,3.3-0.2c48.8,0,97.5,0,146.3,0 c0.9,0,1.7,0.1,2.6,0.1c0,1,0,2,0,2.9c-0.3,2.7-0.6,5.3-0.9,8c-2.8,22.6-7.1,44.9-13.5,66.7c-34.8,119.9-118.9,217.5-232.4,269.3 c-47.9,21.9-98.1,34.3-150.7,37.3c-1.2,0.1-2.4,0.4-3.6,0.6C448.9,852.3,434.4,852.3,419.9,852.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5a82ce68be855b8a53d077588c884def.svg";
export { ForwardRef as ReactComponent };